import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { GiTwoCoins } from "react-icons/gi";
import { FiPlus } from "react-icons/fi";

const LowCoinFloatingButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [expanded, setExpanded] = useState(false);

  const { isAuthenticated, loading, balance, tierlevel } = useAuth();

  const coinBalance = Number(balance || 0);
  const hasLowCoins = coinBalance < 50;

  const shouldShow =
    !loading &&
    isAuthenticated &&
    Number(tierlevel) > 0 &&
    location.pathname !== "/coinbuy" &&
    !location.pathname.startsWith("/login") &&
    !location.pathname.startsWith("/register") &&
    !location.pathname.startsWith("/checkout");

  useEffect(() => {
    const isMobile = window.innerWidth <= 768;

    if (!isMobile || !shouldShow) {
      setExpanded(false);
      return;
    }

    let closeTimer;

    const openTimer = setTimeout(() => {
      setExpanded(true);

      closeTimer = setTimeout(() => {
        setExpanded(false);
      }, 2500);
    }, 1200);

    return () => {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
    };
  }, [shouldShow]);

  if (!shouldShow) return null;

  return (
    <div
      className={`low-coin-floating-btn ${expanded ? "expanded" : ""}`}
      onMouseEnter={() => {
        if (window.innerWidth > 768) {
          setExpanded(true);
        }
      }}
      onMouseLeave={() => {
        if (window.innerWidth > 768) {
          setExpanded(false);
        }
      }}
      onClick={() => navigate("/coinbuy")}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          navigate("/coinbuy");
        }
      }}
    >
      <div className="coin-btn-main">
        <GiTwoCoins className="coin-icon" />
        <FiPlus className="plus-icon" />
      </div>

      <div className="coin-expand-content">
        <div className="coin-expand-title">
          {hasLowCoins ? "Running low on coins" : "Need more coins"}
        </div>

        <div className="coin-expand-subtitle">Buy now</div>
      </div>
    </div>
  );
};

export default LowCoinFloatingButton;